// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__1U22p","alertStatic":"Alert_alertStatic__yIMyE"};